import * as React from 'react';
import { observer } from 'mobx-react';

import { ApplePaymentMethodViewModel } from './apple-payment-method-view-model';
import { CheckboxField } from '../../../components/form-fields';
import { Text } from '../../../components/text';

import * as styles from './apple-payment-method.less';
import { amountToParts, getIndividuallyCalculatedAmountWithFees } from '../../../utils/helper-utils';
import { GiftDescription } from '../../../components/gift/gift-description';
import { Formatter } from '../../../../Shared/utils/formatter';
import { Currency } from '../../../webgiving-generated';
import { SummaryTable } from '../../../components/gift/summary-table';
import { ErrorMessage } from '../../../components/error-message/error-message';
import { getUniqueElementId } from '../../../../Shared/utils/form-control-utils';


const errorMessageElementId = 'apple-payment-method-error-message_' + getUniqueElementId();

@observer
export class ApplePaymentMethod extends React.Component<
	{ vm: ApplePaymentMethodViewModel; toggleCoversFees: (coversFees: boolean) => void },
	{}
> {
	render() {
		const {
			payerElectedToCoverFees,
			merchantInfo: {
				PercentageOfPaymentAddedToCoverFees,
				SupportsPayerCoversFees,
				PaymentLabel,
				TradingName,
				Currency: currency,
			},
			fundName,
			oneTimeGiftDateLabel,
			paymentDetailsText,
			calculatedAmountWithFees,
			lineItems,
			error
		} = this.props.vm;

		const { major, minor } = amountToParts(calculatedAmountWithFees, 2);
		const amountFormatted = Formatter.formatNumberForDisplay(calculatedAmountWithFees, 2);

		const splitLineItems = getIndividuallyCalculatedAmountWithFees(lineItems, this.props.vm.merchantInfo, payerElectedToCoverFees.value);
		const hasSplitItems = splitLineItems.length > 0;
		let numberOfGifts = null;
		if (hasSplitItems) {
			numberOfGifts = splitLineItems.length;
		}

		return (
			<div data-pp-at-target="ApplePay page">
				<div className="row">
					<div className="col-sm-12">
						<div className={styles.title}>
							<Text>{PaymentLabel.VerbSentenceCase}</Text>
						</div>
						<div className={styles.amount}>
							<div className={styles.currencySymbol}>$</div>
							<div className={`${styles.major}`}>
								{major}
								{2 > 0 ? <span>.{minor}</span> : null}
							</div>
						</div>
						<div className={styles.description}>
							<GiftDescription
								recurringInfo={null}
								fundName={fundName}
								numberOfGifts={numberOfGifts}
								currencyCode={Currency[currency]}
								amountFormatted={amountFormatted}
								paymentLabel={PaymentLabel}
								tradingName={TradingName}
								oneTimeGiftDateLabel={oneTimeGiftDateLabel}
								paymentDetailsText={paymentDetailsText}
							/>
							{hasSplitItems && <SummaryTable gifts={splitLineItems} totalAmount={calculatedAmountWithFees} />}
						</div>
						{SupportsPayerCoversFees && (
							<div className={styles.fees}>
								<CheckboxField
									formField={payerElectedToCoverFees}
									label={`Add ${PercentageOfPaymentAddedToCoverFees}% to contribute to processing costs*`}
									acceptanceTestTargetId="PayerCoversFeesCheckbox"
									onChange={this.handleChangePayerCoversFees}
								/>
							</div>
						)}
						<ErrorMessage error={error} id={errorMessageElementId} />
					</div>
				</div>
			</div>
		);
	}

	handleChangePayerCoversFees = () => this.props.toggleCoversFees(this.props.vm.payerElectedToCoverFees.value);
}
